<template>
  <div class="park-detail-info-place">
    <!-- <div class="park-detail-info-sub-title">◇位置</div> -->
    <div v-loading="mapLoading" class="park-detail-info-place-content">
      <tz-map
        v-if="parkId"
        :ref="'placeTzMap' + parkId"
        :position="position"
        :container="'placeMapView' + parkId"
        mw="100%"
        mh="100%"
        :maxZoom="18"
      >
        <tz-toggle-map :base-list="configList" :is-note="true" />
      </tz-map>
    </div>
  </div>
</template>
<script>
// 园区位置组件
export default {
  name: "ParkPlace",
  props: {
    parkCodeActual: String,
    parkId: Number,
  },
  data() {
    return {
      position: [100.264162, 25.615269],
      configList: mapConfig.configList,
      mapView: undefined,
      mapLoading: false,
      layerArr: layerConfig.parkDistributionLayer.layerIndex, //园区分布查询layerIndex
      layerIndex: 0, //园区分布查询起始位置
    };
  },
  watch: {
    parkId(val) {
      if (val) {
        this.$nextTick(() => {
          this.mapView = this.$refs["placeTzMap" + this.parkId].tzApi;
          //this.onParkLocation(this.parkCodeActual);
          this.parkData();
        });
      }
    },
  },
  mounted() {},
  methods: {
    //查询园区
    parkData() {
      this.mapView.queryArcGISRestByAttribute(
        layerConfig.parkDistributionLayer.url,
        this.layerArr[this.layerIndex],
        `产业园代码 = '${this.parkCodeActual}'`,
        (res) => {
          if (res.features && res.features.length) {
            let { geometry, attributes } = res.features[0];
            if (geometry) {
              let zb = geometry.rings;
              //居中地图范围
              let extent = this.mapView.getPolygonExtent(zb);
              this.mapView.zoomToExtent(
                extent[0],
                extent[1],
                extent[2],
                extent[3]
              );
              this.mapView.addVectorMultiPolygon(
                [geometry.rings],
                attributes["开发区名称"] || attributes["产业园名称"],
                { id: "park" },
                "#0000ff80",
                "#0000ff80",
                "#0e1d93",
                "#fff"
              );
            }
          } else {
            if (this.layerIndex < this.layerArr.length) {
              this.layerIndex++;
              this.parkData();
            } else {
              console.log("没有找到对应园区位置");
            }
          }
        }
      );
    },
    //园区定位
    onParkLocation(code) {
      this.mapLoading = true;
      layerConfig.layerArr.forEach((item) => {
        this.mapView.queryArcGISRestByAttribute(
          item.url,
          item.layerIndex,
          `${item.fields} = '${code}'`,
          (res) => {
            this.mapLoading = false;
            if (res.features && res.features.length) {
              let { attributes, geometry } = res.features[0];
              if (geometry) {
                this.mapView.removeVectorFeatureById("kfq_layer");
                let extent = this.mapView.getMultiPolygonExtent([
                  geometry.rings,
                ]);
                this.mapView.zoomToExtent(
                  extent[0],
                  extent[1],
                  extent[2],
                  extent[3]
                );
                this.mapView.addVectorMultiPolygon(
                  [geometry.rings],
                  attributes[item.title],
                  { id: "kfq_layer" },
                  "#04ebf0",
                  "rgba(0,0,0,0)",
                  "#ffffff",
                  "#04ebf0",
                  undefined,
                  undefined,
                  4
                );
              }
            }
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.park-detail-info-sub-title {
  /* margin-top: 20px; */
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-place-content {
  width: calc(100% - 2px);
  height: 450px;
  border: 1px solid #eee;
}
</style>
